import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useLocale } from "@/i18n/LocaleProvider";

export function Layout({ children }: { children: ReactNode }) {
  const { t } = useLocale();
  /* `.sq-legacy` is what keeps this shell's stylesheet off the rebuilt
     screens. src/styles/components-scoped.css prefixes every rule naming a
     class the design also defines; without the wrapper those rules match
     nothing and this shell renders unstyled. Both go when the last screen
     is rebuilt. */
  return (
    <div className="sq-legacy">
      <a className="sq-skip-link" href="#main">{t.nav.skipToContent}</a>
      <Header />
      <main id="main">{children}</main>
      <Footer />
    </div>
  );
}
